import { useTranslations } from '@vocab/react';
import { Checkbox, Stack, Text } from 'braid-design-system';

import translations from 'src/pages/ConnectedPartners/.vocab';
import { analytics } from 'src/utils/analytics/analytics';
import { useQueryHistory } from 'src/utils/hooks/useQueryHistory';
import { slugify } from 'src/utils/slugify';

import { solutionsData } from './solutionsData';

interface Props {
  disabled?: boolean;
}

export const SolutionsFilter = ({ disabled = false }: Props) => {
  const { t } = useTranslations(translations);
  const { includes, pluck, append } = useQueryHistory('solutions');

  const toggleFilter = (value: string) => {
    if (includes(value)) {
      // If it's selected, remove it
      pluck(value);
      analytics.link(slugify({ str: `${value}-filter-off` }));
    } else {
      // Otherwise, add it.
      append(value);
      analytics.link(slugify({ str: `${value}-filter-on` }));
    }
  };

  return (
    <Stack space="xsmall">
      <Text weight="strong">{t('integrationType')}</Text>

      {solutionsData.map((item, index) => (
        <Checkbox
          key={index}
          id={slugify({ str: item.name })}
          checked={includes(item.slug)}
          onChange={() => toggleFilter(item.slug)}
          label={
            t(item.name as 'jobPosting' | 'optimisedApply' | 'applyWithSeeK')!
          }
          disabled={disabled}
        />
      ))}
    </Stack>
  );
};
